import React from 'react';
import MobileTTSContainer from '@src/containers/MobileTTS';

const MobileTTS = () => <MobileTTSContainer />;

export default MobileTTS;
